module.exports = __webpack_public_path__ + "img/TBWTTNL_story.7c0f0bdb.jpg";